// main.jsx
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App from './App';
import WaitList from './pages/WaitList';
import ContactUs from './pages/ContactUs';
import './index.css';
import LastWakeProvider from './helpers/LastWakeProvider';

const router = createBrowserRouter([
  {
    path: '/',
    element: <App />,
  },
  {
    path: 'wait-list',
    element: <WaitList />,
  },
  {
    path: 'contact',
    element: <ContactUs />,
  },
]);

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <LastWakeProvider>
      <RouterProvider router={router} />
    </LastWakeProvider>
  </StrictMode>
);
